import React, { Component } from 'react';
import DatePicker from './datepicker';

export default class DateTimePicker extends Component {
  render() {
    return <DatePicker {...this.props} cFormatData='YYYY-MM-DD HH:mm:ss' />
  }
}



// WEBPACK FOOTER //
// ./src/yxyweb/common/components/basic/datetimepicker.jsx